import { Theme } from '@mui/material';

const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);

export const getInputBorderStyle = ({
  isError,
  theme,
  hideBorder,
}: {
  isError?: boolean;
  theme: Theme;
  hideBorder?: boolean;
}) => ({
  borderWidth: hideBorder ? 0 : isError ? '1px' : isIos ? '1px' : '0.5px',
  borderColor: isError ? 'red' : theme.palette.lightOutlineGrey.main,
});
